import styled from "@emotion/styled";
import { FC, memo } from "react";

import AccountClock from "assets/icons/svg/account-clock.svg?react";
import AddColumn from "assets/icons/svg/add-column.svg?react";
import AddOutline from "assets/icons/svg/add-outline.svg?react";
import AddPerson from "assets/icons/svg/add-person.svg?react";
import Agents from "assets/icons/svg/agents.svg?react";
import AiSummaryGradient from "assets/icons/svg/ai-summary-gradient.svg?react";
import AndroidLogo from "assets/icons/svg/android-logo.svg?react";
import AppLogoFallback from "assets/icons/svg/app-logo-fallback.svg?react";
import AppleLogo from "assets/icons/svg/apple-logo.svg?react";
import Apps from "assets/icons/svg/apps.svg?react";
import Archives from "assets/icons/svg/archives.svg?react";
import ArrowDownCircle from "assets/icons/svg/arrow-down-circle.svg?react";
import ArrowExit from "assets/icons/svg/arrow-exit.svg?react";
import ArrowLeftLong from "assets/icons/svg/arrow-left-long.svg?react";
import ArrowLeftShort from "assets/icons/svg/arrow-left-short.svg?react";
import ArrowLeft from "assets/icons/svg/arrow-left.svg?react";
import ArrowRightShort from "assets/icons/svg/arrow-right-short.svg?react";
import ArrowRight from "assets/icons/svg/arrow-right.svg?react";
import Attachment from "assets/icons/svg/attachment.svg?react";
import BellSleeping from "assets/icons/svg/bell-sleeping.svg?react";
import Bell from "assets/icons/svg/bell.svg?react";
import Block from "assets/icons/svg/block.svg?react";
import BotOutline from "assets/icons/svg/bot-outline.svg?react";
import Calendar from "assets/icons/svg/calendar.svg?react";
import CannedDrawnGray from "assets/icons/svg/canned-drawn-gray.svg?react";
import CannedDrawn from "assets/icons/svg/canned-drawn.svg?react";
import CannedResponse from "assets/icons/svg/canned-response.svg?react";
import CardCode from "assets/icons/svg/card-code.svg?react";
import CardMail from "assets/icons/svg/card-mail.svg?react";
import Cart from "assets/icons/svg/cart.svg?react";
import Chart from "assets/icons/svg/chart.svg?react";
import ChatBarWindow from "assets/icons/svg/chat-bar-window.svg?react";
import ChatBasicWindow from "assets/icons/svg/chat-basic-window.svg?react";
import ChatBubbleWindow from "assets/icons/svg/chat-bubble-window.svg?react";
import ChatBubble from "assets/icons/svg/chat-bubble.svg?react";
import ChatModernWindow from "assets/icons/svg/chat-modern-window.svg?react";
import Chat from "assets/icons/svg/chat.svg?react";
import Chats from "assets/icons/svg/chats.svg?react";
import CheckCircle from "assets/icons/svg/check-circle.svg?react";
import CheckMark from "assets/icons/svg/check-mark.svg?react";
import CheckTicketDrawn from "assets/icons/svg/check-ticket-drawn.svg?react";
import ChevronDown from "assets/icons/svg/chevron-down.svg?react";
import ChevronUp from "assets/icons/svg/chevron-up.svg?react";
import ChildTicket from "assets/icons/svg/child-ticket.svg?react";
import Clock from "assets/icons/svg/clock.svg?react";
import Close from "assets/icons/svg/close.svg?react";
import ClosedLock from "assets/icons/svg/closed-lock.svg?react";
import Code from "assets/icons/svg/code.svg?react";
import ConditionTicket from "assets/icons/svg/condition-ticket.svg?react";
import Copy from "assets/icons/svg/copy.svg?react";
import CreditCard from "assets/icons/svg/credit-card.svg?react";
import CurlyBrackets from "assets/icons/svg/curly-brackets.svg?react";
import CustomDomain from "assets/icons/svg/custom-domain.svg?react";
import CustomFields from "assets/icons/svg/custom-fields.svg?react";
import Customers from "assets/icons/svg/customers.svg?react";
import Customize from "assets/icons/svg/customize.svg?react";
import Danger from "assets/icons/svg/danger.svg?react";
import DayShift from "assets/icons/svg/day-shift.svg?react";
import Desktop from "assets/icons/svg/desktop.svg?react";
import DeveloperConsole from "assets/icons/svg/developer-console.svg?react";
import Development from "assets/icons/svg/development.svg?react";
import Directions from "assets/icons/svg/directions.svg?react";
import Download from "assets/icons/svg/download.svg?react";
import Downloading from "assets/icons/svg/downloading.svg?react";
import Draggable from "assets/icons/svg/draggable.svg?react";
import Edit from "assets/icons/svg/edit.svg?react";
import EmailTemplate from "assets/icons/svg/email-template.svg?react";
import Email from "assets/icons/svg/email.svg?react";
import Emoji from "assets/icons/svg/emoji.svg?react";
import ErrorInfo from "assets/icons/svg/error-info.svg?react";
import Error from "assets/icons/svg/error.svg?react";
import ExpandText from "assets/icons/svg/expand-text.svg?react";
import Extension from "assets/icons/svg/extension.svg?react";
import Eye from "assets/icons/svg/eye.svg?react";
import FacebookLogo from "assets/icons/svg/facebook-logo.svg?react";
import FacebookMessenger from "assets/icons/svg/facebook-messenger.svg?react";
import Facebook from "assets/icons/svg/facebook.svg?react";
import FilledCheckMark from "assets/icons/svg/filled-check-mark.svg?react";
import Filter from "assets/icons/svg/filter.svg?react";
import FilterActivity from "assets/icons/svg/filters/activity.svg?react";
import FilterAgent from "assets/icons/svg/filters/agent.svg?react";
import FilterAgentAssignment from "assets/icons/svg/filters/assignment.svg?react";
import FilterBrowser from "assets/icons/svg/filters/browser.svg?react";
import FilterCheckMarkCircle from "assets/icons/svg/filters/check-mark-circle.svg?react";
import FilterDevice from "assets/icons/svg/filters/device.svg?react";
import FilterEmail from "assets/icons/svg/filters/email.svg?react";
import FilterGroup from "assets/icons/svg/filters/group.svg?react";
import FilterLocation from "assets/icons/svg/filters/location.svg?react";
import FilterName from "assets/icons/svg/filters/name.svg?react";
import FilterNumber from "assets/icons/svg/filters/number.svg?react";
import FilterOs from "assets/icons/svg/filters/os.svg?react";
import FilterPath from "assets/icons/svg/filters/path.svg?react";
import PriorityFilter from "assets/icons/svg/filters/priority.svg?react";
import FilterRate from "assets/icons/svg/filters/rate.svg?react";
import FilterReturning from "assets/icons/svg/filters/returning.svg?react";
import FilterSource from "assets/icons/svg/filters/source.svg?react";
import FilterTime from "assets/icons/svg/filters/time.svg?react";
import FilterWeb from "assets/icons/svg/filters/web.svg?react";
import Followers from "assets/icons/svg/followers.svg?react";
import FormatBold from "assets/icons/svg/format-bold.svg?react";
import FormatItalic from "assets/icons/svg/format-italic.svg?react";
import FormatListBulleted from "assets/icons/svg/format-list-bulleted.svg?react";
import FormatListNumbered from "assets/icons/svg/format-list-numbered.svg?react";
import FormatStrikethrough from "assets/icons/svg/format-strikethrough.svg?react";
import FormatUnderline from "assets/icons/svg/format-underline.svg?react";
import Globe from "assets/icons/svg/globe.svg?react";
import GooglePlusLogo from "assets/icons/svg/google-plus-logo.svg?react";
import GoogleLogo from "assets/icons/svg/google.svg?react";
import Grammar from "assets/icons/svg/grammar.svg?react";
import Group from "assets/icons/svg/group.svg?react";
import PartnerProgram from "assets/icons/svg/handshake.svg?react";
import Help from "assets/icons/svg/help.svg?react";
import HelpDeskDomain from "assets/icons/svg/helpdesk-domain.svg?react";
import HelpDeskFullLogo from "assets/icons/svg/helpdesk-full-logo.svg?react";
import Home from "assets/icons/svg/home.svg?react";
import Image from "assets/icons/svg/image.svg?react";
import Incognito from "assets/icons/svg/incognito.svg?react";
import InfoFilled from "assets/icons/svg/info-filled.svg?react";
import InfoSolid from "assets/icons/svg/info-solid.svg?react";
import Info from "assets/icons/svg/info.svg?react";
import InsertDriveFile from "assets/icons/svg/insert-drive-file.svg?react";
import Language from "assets/icons/svg/language.svg?react";
import LastMessage from "assets/icons/svg/last-message.svg?react";
import LinkExternal from "assets/icons/svg/link-external.svg?react";
import Link from "assets/icons/svg/link.svg?react";
import LivechatFullLogoBlackText from "assets/icons/svg/livechat-full-logo-black-text.svg?react";
import LivechatFullLogoWhiteText from "assets/icons/svg/livechat-full-logo-white-text.svg?react";
import Lock from "assets/icons/svg/lock.svg?react";
import ChatBot from "assets/icons/svg/logo-cb.svg?react";
import Helpdesk from "assets/icons/svg/logo-hd.svg?react";
import KnowledgeBase from "assets/icons/svg/logo-kb.svg?react";
import LiveChatLarge from "assets/icons/svg/logo-lc-large.svg?react";
import LiveChat from "assets/icons/svg/logo-lc.svg?react";
import TextLogo from "assets/icons/svg/logo-text.svg?react";
import MailBlack from "assets/icons/svg/mail-black.svg?react";
import Mail from "assets/icons/svg/mail.svg?react";
import MarketplaceDrawn from "assets/icons/svg/marketplace-drawn.svg?react";
import Marketplace from "assets/icons/svg/marketplace.svg?react";
import Mobile from "assets/icons/svg/mobile-friendly.svg?react";
import ModalInfo from "assets/icons/svg/modal-info.svg?react";
import MoreCasual from "assets/icons/svg/more-casual.svg?react";
import MoreOfficial from "assets/icons/svg/more-official.svg?react";
import MorePolite from "assets/icons/svg/more-polite.svg?react";
import More from "assets/icons/svg/more.svg?react";
import NewWindow from "assets/icons/svg/new-window.svg?react";
import News from "assets/icons/svg/news.svg?react";
import NightShift from "assets/icons/svg/night-shift.svg?react";
import Notifications from "assets/icons/svg/notifications.svg?react";
import OpenInNew from "assets/icons/svg/open-in-new.svg?react";
import PanoramaFishEye from "assets/icons/svg/panorama-fish-eye.svg?react";
import ParentTicket from "assets/icons/svg/parent-ticket.svg?react";
import Person from "assets/icons/svg/person.svg?react";
import Pin from "assets/icons/svg/pin.svg?react";
import Plane from "assets/icons/svg/plane.svg?react";
import Play from "assets/icons/svg/play.svg?react";
import PlusCircle from "assets/icons/svg/plus-circle.svg?react";
import PlusClear from "assets/icons/svg/plus-clear.svg?react";
import Plus from "assets/icons/svg/plus.svg?react";
import Power from "assets/icons/svg/power.svg?react";
import PriorityHigh from "assets/icons/svg/priority-high.svg?react";
import PriorityLow from "assets/icons/svg/priority-low.svg?react";
import PriorityMedium from "assets/icons/svg/priority-medium.svg?react";
import PriorityUrgent from "assets/icons/svg/priority-urgent.svg?react";
import RadioCircle from "assets/icons/svg/radio-circle.svg?react";
import RatedBad from "assets/icons/svg/rated-bad.svg?react";
import RatedGood from "assets/icons/svg/rated-good.svg?react";
import Refresh from "assets/icons/svg/refresh.svg?react";
import Reports from "assets/icons/svg/reports.svg?react";
import RoundBorderCheckMark from "assets/icons/svg/round-border-check-mark.svg?react";
import RoundFilledCheckMark from "assets/icons/svg/round-filled-check-mark.svg?react";
import ScreenRecord from "assets/icons/svg/screen-record.svg?react";
import SearchDrawnGray from "assets/icons/svg/search-drawn-gray.svg?react";
import Search from "assets/icons/svg/search.svg?react";
import SettingsDomainsSection from "assets/icons/svg/section-domains.svg?react";
import SettingsInboxesSection from "assets/icons/svg/section-forwarding-addresses.svg?react";
import SettingsAddressesSection from "assets/icons/svg/section-reply-addresses.svg?react";
import Seen from "assets/icons/svg/seen.svg?react";
import Send from "assets/icons/svg/send.svg?react";
import Settings from "assets/icons/svg/settings.svg?react";
import AddWidgets from "assets/icons/svg/settings/add-widgets.svg?react";
import Check from "assets/icons/svg/settings/check.svg?react";
import Gears from "assets/icons/svg/settings/gears.svg?react";
import Shuffle from "assets/icons/svg/shuffle.svg?react";
import Smartphone from "assets/icons/svg/smartphone.svg?react";
import SmileyHappy from "assets/icons/svg/smiley-happy.svg?react";
import SmileyOkayColored from "assets/icons/svg/smiley-okay-colored.svg?react";
import SmileyOkay from "assets/icons/svg/smiley-okay.svg?react";
import SmileySad from "assets/icons/svg/smiley-sad.svg?react";
import Sort from "assets/icons/svg/sort.svg?react";
import SoundOff from "assets/icons/svg/sound-off.svg?react";
import SoundOn from "assets/icons/svg/sound-on.svg?react";
import SpamTabler from "assets/icons/svg/spam-tabler.svg?react";
import Spam from "assets/icons/svg/spam.svg?react";
import Spinner from "assets/icons/svg/spinner.svg?react";
import Subscription from "assets/icons/svg/subscription.svg?react";
import SurveyOff from "assets/icons/svg/survey-off.svg?react";
import TagDrawn from "assets/icons/svg/tag-drawn.svg?react";
import Tag from "assets/icons/svg/tag.svg?react";
import TeamDrawn from "assets/icons/svg/team-drawn.svg?react";
import TextBlock from "assets/icons/svg/text-block.svg?react";
import TextEnhancements from "assets/icons/svg/text-enhancement.svg?react";
import TextFormat from "assets/icons/svg/text-format.svg?react";
import Text from "assets/icons/svg/text.svg?react";
import ThemeAdditionalTeaks from "assets/icons/svg/theme/additional-tweaks.svg?react";
import ThemeMobileWidget from "assets/icons/svg/theme/mobile-widget.svg?react";
import ThemePosition from "assets/icons/svg/theme/position.svg?react";
import ThemeSocialMedia from "assets/icons/svg/theme/social-media.svg?react";
import ThumbsUp from "assets/icons/svg/thumbs-up.svg?react";
import Ticket from "assets/icons/svg/ticket.svg?react";
import TimeSolid from "assets/icons/svg/time-solid.svg?react";
import Tool from "assets/icons/svg/tool.svg?react";
import TrashBin from "assets/icons/svg/trash-bin.svg?react";
import TwitterLogo from "assets/icons/svg/twitter-logo.svg?react";
import UkraineHeart from "assets/icons/svg/ukraine-heart.svg?react";
import Unfollow from "assets/icons/svg/unfollow.svg?react";
import Unlock from "assets/icons/svg/unlock.svg?react";
import User from "assets/icons/svg/user.svg?react";
import WarningDrawn from "assets/icons/svg/warning-drawn.svg?react";
import Warning from "assets/icons/svg/warning.svg?react";
import WindowsLogo from "assets/icons/svg/windows-logo.svg?react";
import Windows from "assets/icons/svg/windows.svg?react";
import WorldDomainBlack from "assets/icons/svg/world-domain-black.svg?react";
import Zapier from "assets/icons/svg/zapier.svg?react";

interface IStyledIconProps {
  width?: string;
  height?: string;
  inline?: boolean;
  fill?: string;
}

interface IProps {
  name: string;
  width?: string;
  height?: string;
  inline?: boolean;
  fill?: string;
  stroke?: string;
  className?: string;
  testId?: string;
  viewBox?: string;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
}

export enum IconsEnum {
  AccountClock = "account-clock",
  AddColumn = "add-column",
  AddOutline = "add-outline",
  AddPerson = "add-person",
  AddWidgets = "add-widgets",
  Agents = "agents",
  AiSummaryGradient = "ai-summary-gradient",
  AndroidLogo = "android-logo",
  AppleLogo = "apple-logo",
  AppLogoFallback = "app-logo-fallback",
  Apps = "apps",
  Archives = "archives",
  ArrowDownCircle = "arrow-down-circle",
  ArrowExit = "arrow-exit",
  ArrowLeft = "arrow-left",
  ArrowLeftLong = "arrow-left-long",
  ArrowLeftShort = "arrow-left-short",
  ArrowRight = "arrow-right",
  ArrowRightShort = "arrow-right-short",
  Attachment = "attachment",
  AutomationRepeat = "automation-repeat",
  Automations = "automations",
  Bell = "bell",
  BellSleeping = "bell-sleeping",
  Block = "block",
  BotOutline = "bot-outline",
  Calendar = "calendar",
  CannedDrawn = "canned-drawn",
  CannedDrawnGray = "canned-drawn-gray",
  CannedResponse = "canned-response",
  CardCode = "card-code",
  CardMail = "card-mail",
  Cart = "cart",
  Chart = "chart",
  Chat = "chat",
  ChatBarWindow = "chat-bar-window",
  ChatBasicWindow = "chat-basic-window",
  ChatBot = "logo-cb",
  ChatBubble = "chat-bubble",
  ChatBubbleWindow = "chat-bubble-window",
  ChatModernWindow = "chat-modern-window",
  Chats = "chats",
  Check = "check",
  CheckCircle = "check-circle",
  CheckMark = "check-mark",
  CheckTicketDrawn = "check-ticket-drawn",
  ChevronDown = "chevron-down",
  ChevronUp = "chevron-up",
  ChildTicket = "child-ticket",
  Clock = "clock",
  Close = "close",
  ClosedLock = "closed-lock",
  Code = "code",
  ConditionTicket = "condition-ticket",
  Copy = "copy",
  CreditCard = "credit-card",
  CurlyBrackets = "curly-brackets",
  CustomDomain = "custom-domain",
  Customers = "customers",
  CustomFields = "custom-fields",
  Customize = "customize",
  Danger = "danger",
  DayShift = "day-shift",
  Desktop = "desktop",
  DeveloperConsole = "developer-console",
  Development = "development",
  Directions = "directions",
  Download = "download",
  Downloading = "downloading",
  Draggable = "draggable",
  Edit = "edit",
  Email = "email",
  EmailTemplate = "email-template",
  Emoji = "emoji",
  Error = "error",
  ErrorInfo = "error-info",
  ExpandText = "expand-text",
  Extension = "extension",
  ExternalLink = "external-link",
  Eye = "eye",
  Facebook = "facebook",
  FacebookLogo = "facebook-logo",
  FacebookMessenger = "facebook-messenger",
  FilledCheckMark = "filled-check-mark",
  Filter = "filter",
  FilterActivity = "filter-activity",
  FilterAgent = "filter-agent",
  FilterAgentAssignment = "filter-agent-assignment",
  FilterBrowser = "filter-browser",
  FilterCheckMarkCircle = "filter-check-mark-circle",
  FilterDevice = "filter-device",
  FilterEmail = "filter-email",
  FilterGroup = "filter-group",
  FilterLocation = "filter-location",
  FilterName = "filter-name",
  FilterNumber = "filter-number",
  FilterOs = "filter-os",
  FilterPath = "filter-path",
  FilterRate = "filter-rate",
  FilterReturning = "filter-returning",
  FilterSource = "filter-source",
  FilterTime = "filter-time",
  FilterWeb = "filter-web",
  Followers = "followers",
  FormatBold = "format-bold",
  FormatItalic = "format-italic",
  FormatListBulleted = "format-list-bulleted",
  FormatListNumbered = "format-list-numbered",
  FormatStrikethrough = "format-strikethrough",
  FormatUnderline = "format-underline",
  Gears = "gears",
  Globe = "globe",
  GoogleLogo = "google-logo",
  GooglePlusLogo = "google-plus-logo",
  Grammar = "grammar",
  Group = "group",
  Help = "help",
  Helpdesk = "helpdesk",
  HelpDeskDomain = "helpdesk-domain",
  HelpDeskFullLogo = "helpdesk-full-logo",
  Home = "home",
  Image = "image",
  Incognito = "incognito",
  Info = "info",
  InfoFilled = "info-filled",
  InfoSolid = "info-solid",
  InsertDriveFile = "insert-drive-file",
  KnowledgeBase = "logo-kb",
  Language = "language",
  LastMessage = "last-message",
  Link = "link",
  LinkExternal = "link-external",
  LiveChat = "logo-lc",
  LivechatFullLogoBlackText = "logo-lc-full-black-text",
  LivechatFullLogoWhiteText = "logo-lc-full-white-text",
  LiveChatLarge = "logo-lc-large",
  Lock = "lock",
  Mail = "mail",
  MailBlack = "mail-black",
  Marketplace = "marketplace",
  MarketplaceDrawn = "marketplace-drawn",
  Mobile = "Mobile",
  ModalInfo = "modal-info",
  More = "more",
  MoreCasual = "more-casual",
  MoreOfficial = "more-official",
  MorePolite = "more-polite",
  News = "news",
  NewWindow = "new-window",
  NightShift = "night-shift",
  Notifications = "notifications",
  OpenInNew = "open-in-new",
  PanoramaFishEye = "panorama-fish-eye",
  ParentTicket = "parent-ticket",
  PartnerProgram = "partner-program",
  Person = "person",
  Pin = "pin",
  Plane = "plane",
  Play = "play",
  Plus = "plus",
  PlusCircle = "plus-circle",
  PlusClear = "plus-clear",
  Power = "power",
  PriorityFilter = "priority-filter",
  PriorityHigh = "priority-high",
  PriorityLow = "priority-low",
  PriorityMedium = "priority-medium",
  PriorityUrgent = "priority-urgent",
  RadioCircle = "radio-circle",
  RatedBad = "rated-bad",
  RatedGood = "rated-good",
  Refresh = "refresh",
  Reports = "reports",
  RoundBorderCheckMark = "round-border-check-mark",
  RoundFilledCheckMark = "round-filled-check-mark",
  ScreenRecord = "screen-record",
  Search = "search",
  SearchDrawnGray = "search-drawn-gray",
  Seen = "seen",
  Send = "send",
  Settings = "settings",
  SettingsAddressesSection = "settings-addresses-section",
  SettingsDomainsSection = "settings-domains-section",
  SettingsInboxesSection = "settings-inboxes-section",
  Shuffle = "shuffle",
  Smartphone = "smartphone",
  SmileyHappy = "smiley-happy",
  SmileyOkay = "smiley-okay",
  SmileyOkayColored = "smiley-okay-colored",
  SmileySad = "smiley-sad",
  Sort = "sort",
  SoundOff = "sound-off",
  SoundOn = "sound-on",
  Spam = "spam",
  SpamTabler = "spam-tabler",
  Spinner = "spinner",
  Subscription = "subscription",
  SurveyOff = "survey-off",
  Tag = "tag",
  TagDrawn = "tag-drawn",
  TeamDrawn = "text-drawn",
  Text = "text",
  TextBlock = "text-block",
  TextEnhancements = "text-enhancements",
  TextFormat = "text-format",
  TextLogo = "text-logo",
  ThemeAdditionalTeaks = "theme-additional-tweaks",
  ThemeMobileWidget = "theme-mobile-widget",
  ThemePosition = "theme-position",
  ThemeSocialMedia = "theme-social-media",
  ThumbsUp = "thumbs-up",
  Ticket = "ticket",
  TimeSolid = "time-solid",
  Tool = "tool",
  TrashBin = "trash-bin",
  TwitterLogo = "twitter-logo",
  UkraineHeart = "ukraine-heart",
  Unfollow = "unfollow",
  Unlock = "unlock",
  User = "user",
  Warning = "warning",
  WarningDrawn = "warning-drawn",
  Windows = "windows",
  WindowsLogo = "windows-logo",
  WorldDomainBlack = "world-domain-black",
  Zapier = "zapier-logo",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const iconsList: { [key: string]: any } = {
  /* eslint-disable global-require */
  [IconsEnum.AccountClock]: AccountClock,
  [IconsEnum.AddColumn]: AddColumn,
  [IconsEnum.AddOutline]: AddOutline,
  [IconsEnum.AddPerson]: AddPerson,
  [IconsEnum.AddWidgets]: AddWidgets,
  [IconsEnum.Agents]: Agents,
  [IconsEnum.AiSummaryGradient]: AiSummaryGradient,
  [IconsEnum.AndroidLogo]: AndroidLogo,
  [IconsEnum.AppleLogo]: AppleLogo,
  [IconsEnum.AppLogoFallback]: AppLogoFallback,
  [IconsEnum.Apps]: Apps,
  [IconsEnum.Archives]: Archives,
  [IconsEnum.ArrowDownCircle]: ArrowDownCircle,
  [IconsEnum.ArrowExit]: ArrowExit,
  [IconsEnum.ArrowLeft]: ArrowLeft,
  [IconsEnum.ArrowLeftLong]: ArrowLeftLong,
  [IconsEnum.ArrowLeftShort]: ArrowLeftShort,
  [IconsEnum.ArrowRight]: ArrowRight,
  [IconsEnum.ArrowRightShort]: ArrowRightShort,
  [IconsEnum.Attachment]: Attachment,
  [IconsEnum.Bell]: Bell,
  [IconsEnum.BellSleeping]: BellSleeping,
  [IconsEnum.Block]: Block,
  [IconsEnum.BotOutline]: BotOutline,
  [IconsEnum.Calendar]: Calendar,
  [IconsEnum.CannedDrawn]: CannedDrawn,
  [IconsEnum.CannedDrawnGray]: CannedDrawnGray,
  [IconsEnum.CannedResponse]: CannedResponse,
  [IconsEnum.CardCode]: CardCode,
  [IconsEnum.CardMail]: CardMail,
  [IconsEnum.Cart]: Cart,
  [IconsEnum.Chart]: Chart,
  [IconsEnum.Chat]: Chat,
  [IconsEnum.ChatBarWindow]: ChatBarWindow,
  [IconsEnum.ChatBasicWindow]: ChatBasicWindow,
  [IconsEnum.ChatBot]: ChatBot,
  [IconsEnum.ChatBubble]: ChatBubble,
  [IconsEnum.ChatBubbleWindow]: ChatBubbleWindow,
  [IconsEnum.ChatModernWindow]: ChatModernWindow,
  [IconsEnum.Chats]: Chats,
  [IconsEnum.Check]: Check,
  [IconsEnum.CheckCircle]: CheckCircle,
  [IconsEnum.CheckMark]: CheckMark,
  [IconsEnum.CheckTicketDrawn]: CheckTicketDrawn,
  [IconsEnum.ChevronDown]: ChevronDown,
  [IconsEnum.ChevronUp]: ChevronUp,
  [IconsEnum.ChildTicket]: ChildTicket,
  [IconsEnum.Clock]: Clock,
  [IconsEnum.Close]: Close,
  [IconsEnum.ClosedLock]: ClosedLock,
  [IconsEnum.Code]: Code,
  [IconsEnum.ConditionTicket]: ConditionTicket,
  [IconsEnum.Copy]: Copy,
  [IconsEnum.CreditCard]: CreditCard,
  [IconsEnum.CurlyBrackets]: CurlyBrackets,
  [IconsEnum.CustomDomain]: CustomDomain,
  [IconsEnum.Customers]: Customers,
  [IconsEnum.CustomFields]: CustomFields,
  [IconsEnum.Customize]: Customize,
  [IconsEnum.Danger]: Danger,
  [IconsEnum.DayShift]: DayShift,
  [IconsEnum.Desktop]: Desktop,
  [IconsEnum.DeveloperConsole]: DeveloperConsole,
  [IconsEnum.Development]: Development,
  [IconsEnum.Directions]: Directions,
  [IconsEnum.Download]: Download,
  [IconsEnum.Downloading]: Downloading,
  [IconsEnum.Draggable]: Draggable,
  [IconsEnum.Edit]: Edit,
  [IconsEnum.Email]: Email,
  [IconsEnum.EmailTemplate]: EmailTemplate,
  [IconsEnum.Emoji]: Emoji,
  [IconsEnum.Error]: Error,
  [IconsEnum.ErrorInfo]: ErrorInfo,
  [IconsEnum.ExpandText]: ExpandText,
  [IconsEnum.Extension]: Extension,
  [IconsEnum.Eye]: Eye,
  [IconsEnum.Facebook]: Facebook,
  [IconsEnum.FacebookLogo]: FacebookLogo,
  [IconsEnum.FacebookMessenger]: FacebookMessenger,
  [IconsEnum.FilledCheckMark]: FilledCheckMark,
  [IconsEnum.Filter]: Filter,
  [IconsEnum.FilterActivity]: FilterActivity,
  [IconsEnum.FilterAgent]: FilterAgent,
  [IconsEnum.FilterAgentAssignment]: FilterAgentAssignment,
  [IconsEnum.FilterBrowser]: FilterBrowser,
  [IconsEnum.FilterCheckMarkCircle]: FilterCheckMarkCircle,
  [IconsEnum.FilterDevice]: FilterDevice,
  [IconsEnum.FilterEmail]: FilterEmail,
  [IconsEnum.FilterGroup]: FilterGroup,
  [IconsEnum.FilterLocation]: FilterLocation,
  [IconsEnum.FilterName]: FilterName,
  [IconsEnum.FilterNumber]: FilterNumber,
  [IconsEnum.FilterOs]: FilterOs,
  [IconsEnum.FilterPath]: FilterPath,
  [IconsEnum.FilterRate]: FilterRate,
  [IconsEnum.FilterReturning]: FilterReturning,
  [IconsEnum.FilterSource]: FilterSource,
  [IconsEnum.FilterTime]: FilterTime,
  [IconsEnum.FilterWeb]: FilterWeb,
  [IconsEnum.Followers]: Followers,
  [IconsEnum.FormatBold]: FormatBold,
  [IconsEnum.FormatItalic]: FormatItalic,
  [IconsEnum.FormatListBulleted]: FormatListBulleted,
  [IconsEnum.FormatListNumbered]: FormatListNumbered,
  [IconsEnum.FormatStrikethrough]: FormatStrikethrough,
  [IconsEnum.FormatUnderline]: FormatUnderline,
  [IconsEnum.Gears]: Gears,
  [IconsEnum.Globe]: Globe,
  [IconsEnum.GoogleLogo]: GoogleLogo,
  [IconsEnum.GooglePlusLogo]: GooglePlusLogo,
  [IconsEnum.Grammar]: Grammar,
  [IconsEnum.Group]: Group,
  [IconsEnum.Help]: Help,
  [IconsEnum.Helpdesk]: Helpdesk,
  [IconsEnum.HelpDeskDomain]: HelpDeskDomain,
  [IconsEnum.HelpDeskFullLogo]: HelpDeskFullLogo,
  [IconsEnum.Home]: Home,
  [IconsEnum.Image]: Image,
  [IconsEnum.Incognito]: Incognito,
  [IconsEnum.Info]: Info,
  [IconsEnum.InfoFilled]: InfoFilled,
  [IconsEnum.InfoSolid]: InfoSolid,
  [IconsEnum.InsertDriveFile]: InsertDriveFile,
  [IconsEnum.KnowledgeBase]: KnowledgeBase,
  [IconsEnum.Language]: Language,
  [IconsEnum.LastMessage]: LastMessage,
  [IconsEnum.Link]: Link,
  [IconsEnum.LinkExternal]: LinkExternal,
  [IconsEnum.LiveChat]: LiveChat,
  [IconsEnum.LivechatFullLogoBlackText]: LivechatFullLogoBlackText,
  [IconsEnum.LivechatFullLogoWhiteText]: LivechatFullLogoWhiteText,
  [IconsEnum.LiveChatLarge]: LiveChatLarge,
  [IconsEnum.Lock]: Lock,
  [IconsEnum.Mail]: Mail,
  [IconsEnum.MailBlack]: MailBlack,
  [IconsEnum.Marketplace]: Marketplace,
  [IconsEnum.MarketplaceDrawn]: MarketplaceDrawn,
  [IconsEnum.Mobile]: Mobile,
  [IconsEnum.ModalInfo]: ModalInfo,
  [IconsEnum.More]: More,
  [IconsEnum.MoreCasual]: MoreCasual,
  [IconsEnum.MoreOfficial]: MoreOfficial,
  [IconsEnum.MorePolite]: MorePolite,
  [IconsEnum.News]: News,
  [IconsEnum.NewWindow]: NewWindow,
  [IconsEnum.NightShift]: NightShift,
  [IconsEnum.Notifications]: Notifications,
  [IconsEnum.OpenInNew]: OpenInNew,
  [IconsEnum.PanoramaFishEye]: PanoramaFishEye,
  [IconsEnum.ParentTicket]: ParentTicket,
  [IconsEnum.PartnerProgram]: PartnerProgram,
  [IconsEnum.Person]: Person,
  [IconsEnum.Pin]: Pin,
  [IconsEnum.Plane]: Plane,
  [IconsEnum.Play]: Play,
  [IconsEnum.Plus]: Plus,
  [IconsEnum.PlusCircle]: PlusCircle,
  [IconsEnum.PlusClear]: PlusClear,
  [IconsEnum.Power]: Power,
  [IconsEnum.PriorityFilter]: PriorityFilter,
  [IconsEnum.PriorityHigh]: PriorityHigh,
  [IconsEnum.PriorityLow]: PriorityLow,
  [IconsEnum.PriorityMedium]: PriorityMedium,
  [IconsEnum.PriorityUrgent]: PriorityUrgent,
  [IconsEnum.RadioCircle]: RadioCircle,
  [IconsEnum.RatedBad]: RatedBad,
  [IconsEnum.RatedGood]: RatedGood,
  [IconsEnum.Refresh]: Refresh,
  [IconsEnum.Reports]: Reports,
  [IconsEnum.RoundBorderCheckMark]: RoundBorderCheckMark,
  [IconsEnum.RoundFilledCheckMark]: RoundFilledCheckMark,
  [IconsEnum.ScreenRecord]: ScreenRecord,
  [IconsEnum.Search]: Search,
  [IconsEnum.SearchDrawnGray]: SearchDrawnGray,
  [IconsEnum.Seen]: Seen,
  [IconsEnum.Send]: Send,
  [IconsEnum.Settings]: Settings,
  [IconsEnum.SettingsAddressesSection]: SettingsAddressesSection,
  [IconsEnum.SettingsDomainsSection]: SettingsDomainsSection,
  [IconsEnum.SettingsInboxesSection]: SettingsInboxesSection,
  [IconsEnum.Shuffle]: Shuffle,
  [IconsEnum.Smartphone]: Smartphone,
  [IconsEnum.SmileyHappy]: SmileyHappy,
  [IconsEnum.SmileyOkay]: SmileyOkay,
  [IconsEnum.SmileyOkayColored]: SmileyOkayColored,
  [IconsEnum.SmileySad]: SmileySad,
  [IconsEnum.Sort]: Sort,
  [IconsEnum.SoundOff]: SoundOff,
  [IconsEnum.SoundOn]: SoundOn,
  [IconsEnum.Spam]: Spam,
  [IconsEnum.SpamTabler]: SpamTabler,
  [IconsEnum.Spinner]: Spinner,
  [IconsEnum.Subscription]: Subscription,
  [IconsEnum.SurveyOff]: SurveyOff,
  [IconsEnum.Tag]: Tag,
  [IconsEnum.TagDrawn]: TagDrawn,
  [IconsEnum.TeamDrawn]: TeamDrawn,
  [IconsEnum.Text]: Text,
  [IconsEnum.TextBlock]: TextBlock,
  [IconsEnum.TextEnhancements]: TextEnhancements,
  [IconsEnum.TextFormat]: TextFormat,
  [IconsEnum.TextLogo]: TextLogo,
  [IconsEnum.ThemeAdditionalTeaks]: ThemeAdditionalTeaks,
  [IconsEnum.ThemeMobileWidget]: ThemeMobileWidget,
  [IconsEnum.ThemePosition]: ThemePosition,
  [IconsEnum.ThemeSocialMedia]: ThemeSocialMedia,
  [IconsEnum.ThumbsUp]: ThumbsUp,
  [IconsEnum.Ticket]: Ticket,
  [IconsEnum.TimeSolid]: TimeSolid,
  [IconsEnum.Tool]: Tool,
  [IconsEnum.TrashBin]: TrashBin,
  [IconsEnum.TwitterLogo]: TwitterLogo,
  [IconsEnum.UkraineHeart]: UkraineHeart,
  [IconsEnum.Unfollow]: Unfollow,
  [IconsEnum.Unlock]: Unlock,
  [IconsEnum.User]: User,
  [IconsEnum.Warning]: Warning,
  [IconsEnum.WarningDrawn]: WarningDrawn,
  [IconsEnum.Windows]: Windows,
  [IconsEnum.WindowsLogo]: WindowsLogo,
  [IconsEnum.WorldDomainBlack]: WorldDomainBlack,
  [IconsEnum.Zapier]: Zapier,
};

const StyledIconWrapper = styled.div<IStyledIconProps>`
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.inline ? "inline-flex" : "block")
  };
  align-items: center;
  width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.width || "16px"
  };
  height: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.height || "16px"
  };
  line-height: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.height || "16px"
  };
`;

const IconComponent: FC<IProps> = ({ name, testId, width, height, inline, className, ...svgProps }) => {
  const Component = iconsList[name] || null;

  if (!Component) {
    return null;
  }

  return (
    <StyledIconWrapper
      className={className}
      width={width}
      height={height}
      inline={inline}
      fill={svgProps.fill}
      {...(testId ? {} : { "data-testid": testId })}
    >
      <Component {...svgProps} width={width} height={height} />
    </StyledIconWrapper>
  );
};

export const Icon = memo(IconComponent);
